import axios from 'axios'
import router from '@router'
import store from '@store'
import {msgError, openLoading, closeLoading} from '@utils/element'

// 清除IE浏览器请求的缓存
axios.defaults.headers.get['Pragma'] = 'no-cache';
axios.defaults.headers.get['Cache-Control'] = 'no-cache, no-store';

// 创建axios实例对象
const instance = axios.create({
  // 开发时使用代理
  baseURL: process.env.VUE_APP_BASE_API,
  // 超时时间
  timeout: 30000
});

// 开启加载的URL列表
let loadingUrlList = [];

// 判断是否开启加载
function dealLoading(data, url) {
  if (data.closeLoading) {
    delete data.closeLoading
  } else {
    loadingUrlList.push(url);
    openLoading();
  }
}

// 添加请求拦截器
instance.interceptors.request.use(
  // 请求成功时
  function (request) {
    // 添加API
    let url = request.url;
    let api = /license|send\//.test(url) ? "api/v1/" : "adm/v1/";
    request.url = api + url;
    //添加请求标识(取消请求时使用)
    request.cancelToken = store.state.source?.token;
    // 判断是否开启加载
    request.data && dealLoading(request.data, request.url);
    request.params && dealLoading(request.params, request.url);
    //添加token
    let token = store.state.token;
    token && (request.headers['Authorization'] = token);
    return request
  },
  // 请求失败时
  function (error) {
    loadingUrlList = [];
    closeLoading();
    if (!error || error.message !== "cancel") {
      msgError('请求失败！');
      console.log(error);
    }
  }
);

// 添加响应拦截器
instance.interceptors.response.use(
  // 响应成功时
  function (response) {
    // 获取URL
    let url = response.config.url;
    // 判断是否开启加载
    let index = loadingUrlList.indexOf(url);
    index !== -1 && loadingUrlList.splice(index, 1);
    !loadingUrlList.length && closeLoading();
    let res = response.data;
    if (res.code === 0) {
      return res;
    } else if (response.config.responseType === "blob") {
      let reg = /filename="(.*)"/i;
      let disposition = response.headers["content-disposition"];
      disposition && (res.name = disposition.match(reg)[1]);
      return res;
    } else if (res.code === 10021) {
      router.push('/login').catch(() => {});
      msgError('认证超时，请重新登录！');
    } else {
      let msg = res.msg || '';
      if (res.data) {
        msg += '，';
        if (res.data.detail) {
          msg += res.data.detail
        } else {
          msg += res.data
        }
      }
      msgError(msg);
    }
  },
  // 响应失败时
  function (error) {
    loadingUrlList = [];
    closeLoading();
    if (!error || error.message !== "cancel") {
      msgError('响应失败！');
      console.log(error);
    }
  }
);

export default instance;
